<div class="row small my-2"
     *ngIf="summaryItems && summaryItems.length > 0">
  <div class="col-md-4 col-sm-12 py-1 summary-item"
       *ngFor="let item of summaryItems"
       (click)="itemClicked(item)"
       [ngClass]="{ 'cursor-pointer': item.isLink }">

    <span class="text-muted">
      {{ item.title }}:
    </span>

    <span *ngIf="item.isCurrency">
      {{ item.value | currency }}
    </span>

    <span *ngIf="item.isDate">
      {{ item.value | date:'dd/MM/yyyy' }}
    </span>

    <span *ngIf="!item.isCurrency && !item.isDate">
      {{ item.value }}
    </span>

  </div>
</div>
